<template>
	<div>
        <div>
            <el-row>
                <el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
                    <el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
                        Total Data : <br>
                        <span style="font-size:32px;">{{ (totalFbIdentity) }}</span>
                    </el-card>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-select v-model="selectedFilterIdentity" placeholder="Filter By" style="width:140px;" :default-first-option="true" class="mb-10 mr-5">
                        <el-option
                        v-for="itm in filterByIdentity"
                        :key="itm.value"
                        :label="itm.label"
                        :value="itm.value">
                        </el-option>
                    </el-select>
                    <el-input
                        style="width:250px;"
                        class="mb-10"
                        prefix-icon="el-icon-search"
                        placeholder=""
                        clearable
                        v-model="searchFbIdentity">
                    </el-input>
                    <el-button-group class="mr-10 ml-5">
                        <el-button type="primary" :loading="loadingSession" class="animated fadeInRight" @click="changeFilterIdentity">
                            <i class="el-icon-search"/>
                        </el-button>
                    </el-button-group>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-button class="mb-10" style="background-color: #3576F2; color: #FFFFFF;" @click="addDataIdentity">Add New Data</el-button>
                </el-col>
            </el-row>
        </div>

        <template>
            &nbsp;
            <el-pagination
                v-if="paginate"
                background
                prev-text="Prev"
                next-text="Next"
                layout="prev, pager, next"
                :page-size="10"
                @current-change="paginateFbIdentity"
                :current-page="currentPageIdentity"
                :total="parseInt(totalFbIdentity)"/>
            <br/>
            <el-table :data="reqFbIdentity" style="width: 100%;" v-loading="loadingTemplate" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
                <!-- <el-table-column prop="dateCreate" label="Created At" width="200">
                    <template slot-scope="props">
                        <p style="font-weight:bold;">{{ formatDate(props.row.dateCreate, "DD/MM/YY HH:mm:ss") }}</p>
                    </template>
                </el-table-column> -->
                <el-table-column prop="type" label="Type" width="150">
                    <template slot-scope="props">
                        <p style="font-weight:bold;">{{ props.row.type != null ? formatType(props.row.type) : "-" }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="identityNumber" label="Identity Number" width="200">
                    <template slot-scope="props">
                        <p style="font-weight:bold;">{{ props.row.identityNumber }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="maskingName" label="Masking Name" width="250" />
                <!-- <el-table-column prop="price_model" label="Price Model" width="200">
                    <template slot-scope="props">
                        <span v-if="props.row.price_model.length > 0">
                            <el-tag v-for="model in props.row.price_model" :key="model.id" type="success" style="margin: 2px;">
                                {{model.facebook_price.domainName}}
                            </el-tag>
                        </span>
                        <span v-else>
                            -
                        </span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="adminId" label="PIC Business" width="180">
                    <template slot-scope="props">
                        <p v-if="props.row.pic_business != null" style="font-weight:bold;">{{ props.row.pic_business }}</p>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="dateUpdate" label="Updated At" width="180">
                    <template slot-scope="props">
                        <p style="font-weight:bold;">{{ formatDate(props.row.dateUpdate, "DD/MM/YYYY HH:mm:ss") }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="admin" label="Updated By" width="180">
                    <template slot-scope="props">
                        <p style="font-weight:bold;">{{ props.row.admin.username }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="Action"
                    width="300">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.type == 'waba_id'" type="primary" size="small" @click="detailFbIdentity(scope.row)">Detail</el-button>
                        <el-button v-else size="small" @click="detailFbIdentity(scope.row)">Edit</el-button>
                        <el-button size="small" type="danger" @click="deleteFbIdentity(scope.row)">Delete</el-button>
                    </template>
                </el-table-column>
            </el-table>
            &nbsp;
            <el-pagination
                v-if="paginate"
                background
                prev-text="Prev"
                next-text="Next"
                layout="prev, pager, next"
                :page-size="10"
                @current-change="paginateFbIdentity"
                :current-page="currentPageIdentity"
                :total="parseInt(totalFbIdentity)"/>
            <br/>
        </template>

        <el-dialog :close-on-click-modal="false" title="Add Facebook Identity" :visible.sync="dialogFormVisibleIdentity">
		<div v-loading="loadingIdentity">
            <el-form ref="form" label-width="150px">
				<el-form-item label="Type Facebook ID">
                    <template>
                        <el-row>
                            <el-col>
                                <el-select style="width: 100%;" v-model="type_identity" filterable placeholder="Select Type">
									<el-option
									v-for="(item) in types" :key="item.label"
									:label="item.label"
									:value="item.value">
									</el-option>
								</el-select>
                            </el-col>
                        </el-row>
                    </template>
                </el-form-item>

				<el-form-item label="Identity Number">
                    <template>
                        <el-input @keypress.native="numberOnly" @paste.native="paste($event,'identityNumber')" v-model="identityNumber"></el-input>
                    </template>
                </el-form-item>

                <el-form-item label="Masking Name">
                    <template>
                        <el-input v-model="maskingName"></el-input>
                    </template>
                </el-form-item>

                <el-form-item label="PIC Business" v-if="type_identity == 'waba_id'">
                    <el-select @change="handleChangeSelectedPicBusiness" style="width: 100%;" v-model="adminId">
                        <el-option v-for="s in options_picBusiness" filterable :key="s.value" :value="s.user_id" :label="s.label" />
                    </el-select>
                </el-form-item>

				<!-- <el-form-item v-if="type_identity == 'waba_id'" label="Meta Price Model">
                    <template>
                        <el-row v-for="(row,i) in price_model_identity" :key="i">
                            <el-col :span="8">
                                <el-select style="width: 100%;" v-model="row.model.countryName" @change="handleChangeSelectedCountryModel(row.model.countryName,i)" filterable placeholder="Select Country">
                                <el-option
                                v-for="(item) in countries" :key="item.countryCode"
                                :label="item.countryNameEn"
                                :value="item.countryNameEn">
                                <div>
                                    <span style="margin-right: 5px;"><country-flag :country='`${item.countryCode.toLowerCase()}`' size='small'/></span>
                                    <span style="font-size: 12px">{{ item.countryNameEn + ` (+${item.countryCallingCode})` }}</span>
                                </div>
                                </el-option>
                            </el-select>
                            </el-col>
                            <el-col :span="4">
                                <el-input disabled v-model="row.model.domainName"></el-input>
                            </el-col>
                            <el-col :span="8">
                                <el-select :disabled="!row.model.countryName" style="width: 100%;" v-model="row.model.id" @change="handleChangeSelectedModel(row.model.id,i)" filterable placeholder="Select Model">
                                <el-option
                                v-for="(item) in reqFbPriceIdentity[i]" :key="item.id"
                                :label="item.modelName || '-'"
                                :value="item.id">
                                </el-option>
                            </el-select>
                            </el-col>
							<el-col style="text-align: center;" :span="2">
                                <el-button type="primary" size="mini" @click="addModel">+</el-button>
                            </el-col>
							<el-col style="text-align: left;" v-if="i > 0" :span="2">
                                <el-button type="danger" size="mini" @click="deleteModel(i)">-</el-button>
                            </el-col>
                        </el-row>
                    </template>
                </el-form-item> -->

                <el-form-item>
                    <el-button type="primary" @click="addFacebookIdentity" :loading="loadingBtn">Save</el-button>
                    <el-button @click="dialogFormVisibleIdentity=false">Cancel</el-button>
                </el-form-item>
            </el-form>
		
		</div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="Edit Facebook Identity" :visible.sync="dialogFormVisibleEditIdentity">
		<div v-loading="loadingIdentity">
            <el-form ref="form" label-width="180px">
				<el-form-item label="Type Facebook ID">
                    <template>
                        <el-row>
                            <el-col>
                                <el-select style="width: 100%;" v-model="editIdentity.type" @change="handleChangeSelectedIdentity" filterable placeholder="Select Type">
									<el-option
									v-for="(item) in types" :key="item.label"
									:label="item.label"
									:value="item.value">
									</el-option>
								</el-select>
                            </el-col>
                        </el-row>
                    </template>
                </el-form-item>

				<el-form-item label="Identity Number">
                    <template>
                        <el-input @keypress.native="numberOnly" @paste.native="paste($event,'editIdentity','identityNumber')" v-model="editIdentity.identityNumber"></el-input>
                    </template>
                </el-form-item>

                <el-form-item label="Masking Name">
                    <template>
                        <el-input v-model="editIdentity.maskingName"></el-input>
                    </template>
                </el-form-item>

                <el-form-item label="PIC Business" v-if="editIdentity.type == 'waba_id'">
                    <el-select @change="handleChangeSelectedPicBusiness" style="width: 100%;" v-model="editIdentity.adminId">
                        <el-option v-for="s in options_picBusiness" filterable :key="s.value" :value="s.user_id" :label="s.label" />
                    </el-select>
                </el-form-item>

				<!-- <el-form-item v-if="editIdentity.type == 'waba_id'" label="Meta Price Model">
                    <template>
                        <el-row v-for="(row,i) in editIdentity.price_model" :key="i">
                            <el-col :span="8">
                                <el-select style="width: 100%;" v-model="row.facebook_price.countryName" @change="handleChangeSelectedCountryModelEdit(row.facebook_price.countryName,i)" filterable placeholder="Select Country">
                                <el-option
                                v-for="(item) in countries" :key="item.countryCode"
                                :label="item.countryNameEn"
                                :value="item.countryNameEn">
                                <div>
                                    <span style="margin-right: 5px;"><country-flag :country='`${item.countryCode.toLowerCase()}`' size='small'/></span>
                                    <span style="font-size: 12px">{{ item.countryNameEn + ` (+${item.countryCallingCode})` }}</span>
                                </div>
                                </el-option>
                            </el-select>
                            </el-col>
                            <el-col :span="4">
                                <el-input disabled v-model="row.facebook_price.domainName"></el-input>
                            </el-col>
                            <el-col :span="8">
                                <el-select :disabled="!row.facebook_price.countryName" style="width: 100%;" v-model="row.facebook_price.id" @change="handleChangeSelectedModelEdit(row.facebook_price.id,i)" filterable placeholder="Select Model">
                                <el-option
                                v-for="(item) in reqFbPriceIdentity[i]" :key="item.id"
                                :label="item.modelName || '-'"
                                :value="item.id">
                                </el-option>
                            </el-select>
                            </el-col>
							<el-col style="text-align: center;" :span="2">
                                <el-button type="primary" size="mini" @click="addModelEdit">+</el-button>
                            </el-col>
							<el-col style="text-align: left;" v-if="i > 0" :span="2">
                                <el-button type="danger" size="mini" @click="deleteModelEdit(i)">-</el-button>
                            </el-col>
                        </el-row>
                    </template>
                </el-form-item> -->

				<el-form-item label="Created By">
                    <template>
                        <el-input disabled v-model="editIdentity.adminName"></el-input>
                    </template>
                </el-form-item>

				<el-form-item label="Created At">
                    <template>
                        <el-input disabled :value="this.formatDate(editIdentity.dateCreate, 'DD/MM/YYYY HH:mm:ss')"></el-input>
                    </template>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="editFacebookIdentity" :loading="loadingBtn">Save</el-button>
                    <el-button @click="dialogFormVisibleEditIdentity=false, paginateFbIdentity()">Cancel</el-button>
                </el-form-item>
            </el-form>
		</div>
        </el-dialog>
    </div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const _ = require('lodash')
const moment = require('moment')
import CountryFlag from 'vue-country-flag'
const countryCodes = require('country-codes-list')

export default {
	name: 'Facebook_Identinty',
    props: {
        dataIdentity: {
            type: Array
        },
        loadingData: {
            type: Boolean
        },
        // showAlert: {
        //     type: Boolean
        // },
        total: {
            type : Number
        }
    },
	data () {
		return {
			paginate: true,
			bodyStyle: {
				padding: "20px"
			},
            adminId: "",
            options_picBusiness: [],
			filterByIdentity: [{value:"waba_id", label:"WABA ID"},{value:"masking_name", label:"Masking Name"},{value:"pic_business", label:"PIC Business"}],
			selectedFilterIdentity: "waba_id",
            country_code: '',
            country_name: "",
            domain_name: '',
			types: [{label: "WABA ID", value: "waba_id"},{label: "FBBM ID", value: "fbbm_id"}],
            countries: [],
			mapingCountries: [],
			reqFbPriceIdentity:[],
			price_model_identity:[{model:{modelName: "",countryName: "", domainName:""}}],
            model_name:"",
			type_identity:"waba_id",
			identityNumber: "",
			maskingName: "",
            price_model: "1",
			price_model_edit: "1",
			editIdentity: {},
			reqFbIdentity: [],
			loadingTemplate: true,
            loadingSession: false,
			loadingIdentity: false,
			currentPage: 1,
			currentPageRequest: 1,
			currentPageIdentity: 1,
			totalFbIdentity: 0,
			dialogFormVisibleIdentity:false,
			dialogFormVisibleEditIdentity:false,
			loadingBtn:false,
			formLabelWidth: '200px',
			timeout: null,
			searchFbIdentity:'',
			loadingApproved: false
		}
	},
    components: {
        CountryFlag
    },
	methods: {
        log(message) {
            console.log(message, " <<message")
        },
		changeFilterIdentity(){
            // clearTimeout(this.timeout)
			// this.timeout = setTimeout(()=>{
			// 	this.buildQueryParam("query", this.selectedFilterIdentity)
			// 	this.getFbIdentity()
			// }, 1000)
			// this.currentPage = 1
			// this.paginate = this.searchFbIdentity.trim() == '' ? true:false
            this.currentPageIdentity = 1
            // await this.loadSummary()
			this.getFbIdentity(this.currentPageIdentity, this.selectedFilterIdentity)
			// this.getFbIdentity(1,this.selectedFilterIdentity)
		},
        buildQueryParam(key = null, val = null){
			// let q = window.location.search.split("?")
			// q.shift()
			// console.log(q)
			// if(q.length < 1){
			// 	q = { [key]: val }
			// } else {
			// 	_.map(q[0].split("&"), (val, key) => {
			// 		let [k, v] = val.split("=")
			// 		q.push({ [k]: v })
			// 	})
			// }
			// console.log(q)
			// let query =_.map(q, (val, key) => {
			// 	return { key: key, value: val }
			// })
			// if(key != null) {
			// 	let index = _.findIndex(query, v => v.key == key)
			// 	if(index !== -1){
			// 		query[index] = { key: key, value: val }
			// 	} else {
			// 		query.push({ key: key, value: val })
			// 	}
			// }
			// query = query.filter(v => { return v.value != null && v.value != "" })
			// // this.$route.query[key] = val
			// window.history.replaceState(null, null, "?" + query.map((v, k) => { return v.key + "=" + v.value }).join("&"));
		},
		find_duplicate_in_array(arra1, param) {
			var object = {};
			var result = [];

			arra1.forEach(function (item) {
			if(!object[item[param].countryName])
				object[item[param].countryName] = 0;
				object[item[param].countryName] += 1;
			})

			for (var prop in object) {
			if(object[prop] >= 2) {
				result.push(prop);
			}
			}

			return result;

		},
		addDataIdentity(){
			this.mapingCountries = this.countries
			this.dialogFormVisibleIdentity = true
		},
		formatType(val){
			let result = ""
			result = val.replace("_", " ").toUpperCase();
			return result ;
		},
		formatPrice(val){
			return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(val);
		},
        numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        async loadAdmin(page = null, search){
			// this.loadingConsumen = true
			var self = this
			await api({
				url:config.baseApi+'admin_credential?page=' + page + '&query=' + search,
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					// console.log('fatal error')
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					let admin = response.data.data.admin
					// console.log("dp_user",this.dp_user)
					// let dp_user = []
                    admin = admin.map(val => {
                        val.value = val.username
                        val.label = val.username.charAt(0).toUpperCase() + val.username.slice(1)

                        return val
                    })
					console.log('admin',admin);
                    this.options_picBusiness = admin
				}
			}).catch(error => {
				console.log("Error",error)
			})
			// this.loadingConsumen = false
		},
        paste(event, field, field2 = undefined) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }

			console.log(field);
			console.log(FilteredChars);

			if (field2) {
				this[field][field2] = FilteredChars
			}
			else{
				this[field] = FilteredChars
			}
        },
		async detailFbIdentity(val){
			console.log(val);
			this.editIdentity = val
			this.editIdentity.adminName = val.admin.username || ''
			if (this.editIdentity.type == 'waba_id') {
				this.detailPrice(val.id)
				// if (this.editIdentity.price_model.length > 0) {
				// 	this.editIdentity.price_model.forEach( async (el,i) => {
				// 		this.searchFbPrice = el.facebook_price.countryName
				// 		await this.getFbPrice()
				// 		this.reqFbPriceIdentity[i] = this.reqFbPrice
				// 	})
				// }
				// else{
				// 	this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
				// }
			}
			else{
				this.dialogFormVisibleEditIdentity = true
			}
			// setTimeout(() => {
			// 	this.dialogFormVisibleEditIdentity = true
			// }, 100);
		},
		handleChangeSelectedIdentity(val){
			console.log(val);
			if (val == "waba_id" && this.editIdentity.price_model.length == 0) {
				this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
			}
		},
        handleChangeSelectedPicBusiness(val){
            console.log(val);
        },
		deleteFbIdentity(row){
			console.log('row selectd',row)
			this.$confirm(`Are you sure to delete this identity?`, 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true
			}).then(async () => {
                this.loadingApproved = true
                await api({
                    url: config.baseApi + `bussiness/remove-fb-identity/${row.id}`,
                    method: 'delete'
                }).then(res => {
                    this.loadingProduct=true
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), res.data.message, "error").then(this.clear())
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
						this.paginateFbIdentity()
						this.paginateFbPrice(this.currentPage)
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    return err
                })
                this.loadingApproved=false
            })
		},
		deleteRow(index, rows) {
            rows.splice(index, 1);
        },
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
			if(val) return moment(val).format(format)
			else return "-"
		},
		async addFacebookIdentity(){
			if(_.isEmpty(this.type_identity) || _.isEmpty(this.maskingName) || _.isEmpty(this.identityNumber)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }

			// let duplicate = this.find_duplicate_in_array(this.price_model_identity,'model')
			// console.log(duplicate);
			// if (duplicate.length > 0) {
			// 	this.$message.error({
            //         showClose: false,
            //         message: "Country Model can't duplicate"
            //     });
            //     return
			// }

			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/add-fb-identity',
				method:'POST',
				data:{
					type: this.type_identity,
					maskingName: this.maskingName,
					identityNumber: this.identityNumber,
                    adminId: this.type_identity == 'waba_id' ? this.adminId : null
					// price_model : this.price_model_identity
				}
			}).then(response => {
                this.dialogFormVisibleIdentity = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogFormVisible = false
					this.clear()
					this.paginateFbIdentity()
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogFormVisibleIdentity = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
				return error
			})
		},
		async editFacebookIdentity(){
			console.log(this.editIdentity);
			if(!this.editIdentity.id){
                this.$message.error({
                    showClose: false,
                    message: 'Id is undefined'
                });
                return
            }

			// let duplicate = this.find_duplicate_in_array(this.editIdentity.price_model,'facebook_price')
			// console.log(duplicate);
			// if (duplicate.length > 0) {
			// 	this.$message.error({
            //         showClose: false,
            //         message: "Country Model can't duplicate"
            //     });
            //     return
			// }

			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/update-fb-identity',
				method:'POST',
				data:{
					id: this.editIdentity.id,
					type:this.editIdentity.type,
					identityNumber:this.editIdentity.identityNumber,
					maskingName:this.editIdentity.maskingName
                    // adminId: this.editIdentity.type == 'waba_id' ? this.adminId : null
					// price_model:this.editIdentity.price_model
				}
			}).then(response => {
                this.dialogFormVisibleEditIdentity = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogFormVisible = false
					this.paginateFbIdentity()
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogFormVisibleEditIdentity = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
				this.paginateFbIdentity()
				return error
			})
		},
		async paginateFbIdentity(page) {
			// this.currentPageIdentity = page
			// await this.getFbIdentity(page)
			this.currentPageIdentity = page
			await this.getFbIdentity(page)
		},
		async getFbIdentity(page = 1, filter = null){
			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-identity',
				method: 'GET',
				params: {
					page: page,
					all: filter ? true: null,
					filter: this.selectedFilterIdentity,
					search: this.searchFbIdentity
				}
			}).then(({ data }) => {
				// console.log("fb identity",data.data.consumen);
				this.reqFbIdentity = data.data.consumen
				// if(filter){
					this.totalFbIdentity = data.data.total
				// }
				// else{
				// 	this.totalFbIdentity = data.data.total
					
				// }
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async detailPrice(param){
			this.$router.push('business/' + param)
		},
		clear(){
			this.editIdentity = {}
			this.price_model_identity = [{model:{modelName: "",countryName: "", domainName:""}}]
			this.type_identity = "waba_id"
			this.maskingName = ""
			this.identityNumber = ""
            this.adminId = ""
		}
	},
    watch: {
        dataIdentity: function() {
            this.reqFbIdentity = this.dataIdentity
        },
        loadingData: function() {
           this.loadingTemplate = this.loadingData          
        },
        total: function() {
            this.totalFbIdentity = this.total
        }
    },
	async mounted(){
        await this.loadAdmin()
        await this.getFbIdentity()
	},
    created(){
        this.countries = countryCodes.all()
    }
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
